module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Heart-43c00c821caf22392ad4737bc25c8b29.svg";